


























































































































































































































































































































































































import PluginComponent from '@/components/plugins/PluginComponent';
import FormTextInput from '@/components/shared/FormTextInput.vue';
import AnnotationLayerConfig from '@/models/map-context/AnnotationLayerConfig';
import EditionToolType from '@/models/map-context/EditionToolType';
import LayerConfig from '@/models/map-context/LayerConfig';
import FillStyle from '@/models/map-context/style/FillStyle';
import StrokeStyle from '@/models/map-context/style/StrokeStyle';
import TextStyle from '@/models/map-context/style/TextStyle';
import CesiumSelectionService from '@/services/CesiumSelectionService';
import EditionService from '@/services/EditionService';
import { EventBus, EVENTS } from '@/services/EventBus';
import MapService from '@/services/MapService';
import SelectionService from '@/services/SelectionService';
import { unByKey } from 'ol/Observable';
import Component from 'vue-class-component';
import * as olFormatGeoJSON from 'ol/format/GeoJSON';
import * as olFormatGPX from 'ol/format/GPX';
import * as olFormatKML from 'ol/format/KML';
import VectorSource from 'ol/source/Vector';
import Application from '@/models/map-context/Application';
import SymbolStyle from '@/models/map-context/style/SymbolStyle';
import { Fill, Stroke, Style, Text } from 'ol/style';

@Component({
  props: {},
  components: {
    FormTextInput,
  },
})
export default class AnnotationPlugin extends PluginComponent {
  layer!: LayerConfig;

  fontList = [
    'Arial',
    'Courier New',
    'Georgia',
    'Tahoma',
    'Times New Roman',
    'Trebuchet MS',
    'Verdana',
  ];

  isArrow = false;

  symbolOptions = [
    {
      item: 'circle',
      name: '●',
    },
    {
      item: 'square',
      name: '■',
    },
    {
      item: 'cross',
      name: 'x',
    },
    {
      item: 'triangle',
      name: '▲',
    },
    {
      item: 'star',
      name: '★',
    },
  ];

  selectionService!: SelectionService | CesiumSelectionService;

  selectedType: string | null = null;

  editionService!: EditionService;

  DEFAULT_UID = 'annotations';

  mainMenu = true;

  listenerKey: any;

  menu = '';

  exportOptions = ['GeoJSON', 'GPX', 'KML'];

  exportFormat = 'GeoJSON';

  showFormatList = false;

  textStyle = new TextStyle({
    textFillColor: '#000000',
    textFontSize: 30,
    textFontFamily: 'Arial',
    textRotation: 0,
  });

  fillStyle = new FillStyle({ 
    fillColor: 'rgba(233,233,233,0.7)'
   });

  strokeStyle = new StrokeStyle({strokeWidth:1,color:'#000000FF'});

  symbolStyle = new SymbolStyle({symbolStrokeColor:'#000000FF',
    rotation:0,
    size:15
  });

  symbolType = this.symbolOptions[0];

  currentFeature: any = undefined;

  created() {
    this.selectionService = this.getMapService().selectionService;
    const mapService = this.getMapService();
    if (mapService instanceof MapService) {
      this.editionService = mapService.editionService;
    }
  }

  importFile() {
    // Créez un input pour sélectionner un fichier
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.geojson,.gpx,.kml';
    input.addEventListener('change', this.handleFileImport.bind(this));
    input.click();
  }

  handleFileImport(event: any) {
    const file = event.target.files[0];
    if (!file) {
      console.error('Aucun fichier sélectionné.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const content = e.target.result;
      let features: any = null;

      try {
        if (file.name.endsWith('.geojson')) {
          const format = new olFormatGeoJSON.default();
          features = format.readFeatures(content);
        } else if (file.name.endsWith('.gpx')) {
          const format = new olFormatGPX.default();
          features = format.readFeatures(content);
        } else if (file.name.endsWith('.kml')) {
          const format = new olFormatKML.default();
          features = format.readFeatures(content);
        } else {
          EventBus.$emit(EVENTS.ERROR, "Le type de fichier n'est pas pris en charge");
        }

        if (features) {
          this.addFeaturesToLayer(features);
        }
      } catch (error: any) {
        EventBus.$emit(EVENTS.ERROR, "Erreur lors de l'importation du fichier", error);
      }
    };

    reader.readAsText(file);
  }

  addFeaturesToLayer(features: any) {
    if (!this.layer) {
      console.error("Aucune couche d'annotation disponible.");
      return;
    }

    const vectorSource = this.layer.getOlLayer().getSource() as VectorSource;
    if (!vectorSource) {
      console.error("Impossible d'obtenir la source vectorielle.");
      return;
    }

    vectorSource.addFeatures(features);

    const extent = vectorSource.getExtent();
    if (extent) {
      this.getOpenLayersMapService().map.getView().fit(extent, { duration: 1000 });
    }
  }

  saveContext() {
    this.contextService.checkAndSaveContext(this.$router);
  }

  exportFile(format: string) {
    this.showFormatList = false;
    if (this.layer) {
      const layerSource = this.layer.getLayerSource();

      if (layerSource && layerSource.getFeatures) {
        const features = layerSource.getFeatures();
        if (features.length > 0) {
          let exportedData;
          let mimeType;
          let fileExtension;

          // Choisir le format d'exportation
          switch (format) {
            case 'GeoJSON':
              const geoJsonFormat = new olFormatGeoJSON.default();
              exportedData = geoJsonFormat.writeFeatures(features);
              mimeType = 'application/json';
              fileExtension = 'geojson';
              break;
            case 'KML':
              const kmlFormat = new olFormatKML.default();
              exportedData = kmlFormat.writeFeatures(features);
              mimeType = 'application/vnd.google-earth.kml+xml';
              fileExtension = 'kml';
              break;
            case 'GPX':
              const gpxFormat = new olFormatGPX.default();
              exportedData = gpxFormat.writeFeatures(features);
              mimeType = 'application/gpx+xml';
              fileExtension = 'gpx';
              break;
            default:
              EventBus.$emit(EVENTS.ERROR, "Le type de fichier n'est pas pris en charge");
              return;
          }

          // Créer et télécharger le fichier
          const blob = new Blob([exportedData], { type: mimeType });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = `annotations.${fileExtension}`;
          link.click();

          // Libérer l'objet URL
          URL.revokeObjectURL(link.href);
        } else {
          EventBus.$emit(EVENTS.ERROR, 'Aucune entité à exporter.');
        }
      } else {
        EventBus.$emit(EVENTS.ERROR, 'Source de la couche non valide ou manquante.');
      }
    } else {
      EventBus.$emit(EVENTS.ERROR, "La couche n'est pas disponible.");
    }
  }

  onFeatureSelected(features: any) {
    console.log(features);
    this.currentFeature = undefined;
    if (features) {
      const type = features.get('objType');
      
      this.mainMenu = false;
      this.currentFeature = features;
      this.menu='';
      this.updateForm(this.currentFeature);
      setTimeout(()=>{
        
        this.menu=type;
      },100)
      
    }
  }


  mounted() {
    EventBus.$emit(EVENTS.DISABLE_SELECTION);
    EventBus.$on(EVENTS.SELECT_DRAW, this.onFeatureSelected);
    EventBus.$emit(EVENTS.NOTIFICATION, 'Pour déplacer un objet maintenez la touche CTRL (COMMAND sous MAC) enfoncée  ');
    let layer = this.contextService.getCurrentContext().getLayerByUid(this.DEFAULT_UID);
    if (layer) {
      this.editionService.reset();
      this.layer = layer;
      
      //this.editionService.activeSelection(this.layer);
    } else {
      this.addVectorLayer();
    }
    this.editionService.updateShape(this.layer);
    this.listenerKey = this.layer.getLayerSource().on('addfeature', (evt: any) => {
      this.currentFeature = evt.feature;
      this.updateProperties(this.currentFeature);
      // on active le mode modification
      this.editionService.reset();
      this.editionService.updateShape(this.layer);
    });
  }

  onChangeValue() {
    if (this.currentFeature) {
      this.updateProperties(this.currentFeature);
    }
  }

  onChangeSymbolType(event: any) {
    if (this.currentFeature) {
      let feature: any = this.currentFeature;
      feature.set('type', event.item);
    }
  }

  toggleFormatList() {
    this.showFormatList = !this.showFormatList;
  }
  updateForm(feature: any) {
    const type = feature.get('objType');
    if (type == 'text') {
      this.textStyle.text=feature.get('text');
      this.textStyle.textFontSize=feature.get('fontSize');
      this.textStyle.textFontFamily=feature.get('fontFamily');
      this.textStyle.textFillColor=feature.get('fontColor');
      this.textStyle.textRotation=feature.get('textRotation');
    } else if (type == 'poly' || type == 'circle') {
      this.fillStyle.fillColor=feature.get('fillColor');
      this.strokeStyle.strokeWidth=feature.get('strokeWidth');
      this.strokeStyle.color=feature.get('color');
    } else if (type == 'line') {
      this.strokeStyle.strokeWidth=feature.get('strokeWidth');
      this.strokeStyle.color=feature.get('color');
      this.isArrow=feature.get('arrow');

    } else if (type == 'symbol') {
      this.symbolType.item=feature.get('type');
      this.symbolStyle.rotation=feature.get('rotation');
      this.symbolStyle.size=feature.get('size');
      this.symbolStyle.symbolStrokeColor=feature.get('color');

    }
    //TODO add case for lines and points
  }

  updateProperties(feature: any) {
    feature.set('objType', this.menu);
    if (this.menu == 'text') {
      feature.set('text', this.textStyle.getText());
      feature.set('fontSize', this.textStyle.getTextFontSize());
      feature.set('fontFamily', this.textStyle.getFontFamily());
      feature.set('fontColor', this.textStyle.getTextFillColor());
      feature.set('textRotation', this.textStyle.getTextRotation());
    } else if (this.menu == 'poly' || this.menu == 'circle') {

      if(this.menu == 'circle'){
        feature.set('radius', feature.getGeometry().getRadius());
        feature.set('center', feature.getGeometry().getCenter());
      }
      feature.set('fillColor', this.fillStyle.getFillColor());
      feature.set('strokeWidth', this.strokeStyle.getStrokeWidth());
      feature.set('color', this.strokeStyle.getColor());
    } else if (this.menu == 'line') {
      feature.set('strokeWidth', this.strokeStyle.getStrokeWidth());
      feature.set('color', this.strokeStyle.getColor());
      feature.set('arrow', this.isArrow);
    } else if (this.menu == 'symbol') {
      feature.set('type', this.symbolType.item);
      feature.set('rotation', this.symbolStyle.rotation);
      feature.set('size', this.symbolStyle.getSize());
      feature.set('color', this.symbolStyle.getSymbolStrokeColor());
    }
    //TODO add case for lines and points
  }

  addText() {
    this.mainMenu = false;
    this.menu = 'text';
    this.editionService.reset();
    this.editionService.activeEdition(EditionToolType.ADD_POINT, this.layer);
  }
  addPolygon() {
    this.mainMenu = false;
    this.menu = 'poly';
    this.editionService.reset();
    this.editionService.activeEdition(EditionToolType.ADD_POLYGON, this.layer);
  }

  addSymbol() {
    this.mainMenu = false;
    this.menu = 'symbol';
    this.editionService.reset();
    this.editionService.activeEdition(EditionToolType.ADD_POINT, this.layer);
  }

  addLine() {
    this.mainMenu = false;
    this.menu = 'line';
    this.editionService.reset();
    this.editionService.activeEdition(EditionToolType.ADD_LINE, this.layer);
  }

  addCircle() {
    this.mainMenu = false;
    this.menu = 'circle';
    //this.symbolType='circle';
    this.editionService.reset();
    this.editionService.activeEdition(EditionToolType.ADD_REAL_CIRCLE, this.layer);
  }

  deleteAllObjects() {
    if (this.layer) {
      const source = this.layer.getLayerSource();
      if (source) {
        source.clear();
      }
    }
  }

  deleteObject() {
    //this.editionService.activeEdition(EditionToolType.DELETE_SELECT, this.layer);
    this.layer.getLayerSource().removeFeature(this.currentFeature);
    this.retour();
  }
  //TODO add case for lines and points

  retour() {
    this.mainMenu = true;
    this.menu = '';
    this.editionService.reset();
    this.currentFeature = undefined;
    //this.editionService.activeSelection(this.layer);
    this.editionService.updateShape(this.layer);
    // this.editionService.reset();
  }

  beforeDestroy() {
    //unbind listeners
    this.editionService.reset();
    EventBus.$emit(EVENTS.ENABLE_SELECTION);
    EventBus.$off(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    EventBus.$off(EVENTS.SELECT_DRAW, this.onFeatureSelected);
    if (this.listenerKey) {
      unByKey(this.listenerKey);
    }
  }

  private addLayerToMap(newLayer: LayerConfig) {
    try {
      this.contextService.getCurrentContext().getLayers().unshift(newLayer);
      this.getMapService().addLayer(newLayer);
    } catch (error: any) {
      newLayer.addError(error);
      EventBus.$emit(EVENTS.ERROR, error);
    }
  }

  addVectorLayer() {
    const newLayer: LayerConfig = new AnnotationLayerConfig({
      uid: this.DEFAULT_UID,
      title: 'Nouveau Dessin',
      type: 'annotations',
      queryable: false,
      visible: true,
      //editable: true,
      layerProperties: [],
      boundingBoxEPSG4326: [-180, -90, 180, 90],
    });
    this.layer = newLayer;
    this.addLayerToMap(newLayer);
  }
}
